import React, { useState } from 'react'
import { createChatbotFeedback } from '../../api'

const BotFeedback = ({
  messageId,
  botResponse,
  query,
  role,
  personId,
  roomId,
  feedbacks = []
}) => {
  const existingFeedback = feedbacks.find((f) => f.message_id === messageId)
  const initialFeedback = existingFeedback
    ? existingFeedback.feedback === 'Helpful'
      ? 'helpful'
      : 'not-helpful'
    : null

  const [feedback, setFeedback] = useState(initialFeedback)
  const [showThanks, setShowThanks] = useState(false)

  const getFeedbackValue = (feedbackType) => {
    const feedbackMap = {
      helpful: 'Helpful',
      'not-helpful': 'Not Helpful'
    }
    return feedbackMap[feedbackType] || null
  }

  const handleFeedback = async (type) => {
    const newFeedback = feedback === type ? null : type
    setFeedback(newFeedback)
    setShowThanks(newFeedback !== null)

    try {
      await createChatbotFeedback({
        message_id: messageId,
        query: query,
        bot_response: botResponse,
        feedback: getFeedbackValue(newFeedback),
        role: role,
        person_id: personId,
        room_id: roomId
      })
    } catch (error) {
      console.error('Failed to send feedback:', error)
    }
  }

  return (
    <>
      <div className="message-feedback">
        <span className="feedback-text">Was this helpful?</span>
        <div className="feedback-buttons">
          <button
            type="button"
            className={`feedback-btn ${feedback === 'helpful' ? 'active' : ''}`}
            onClick={() => handleFeedback('helpful')}
          >
            👍
          </button>
          <button
            type="button"
            className={`feedback-btn ${
              feedback === 'not-helpful' ? 'active' : ''
            }`}
            onClick={() => handleFeedback('not-helpful')}
          >
            👎
          </button>
        </div>
      </div>
      {showThanks && (
        <div className="feedback-text">Thanks for your feedback!</div>
      )}
    </>
  )
}

export default BotFeedback
